import _typeof from "@babel/runtime/helpers/typeof";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { Catch } from '@tokamakjs/common';
import { Component } from 'react';
var ALREADY_HANDLED = Symbol('ALREADY_HANDLED');
var HANDLER_INDEX = Symbol('HANDLER_INDEX');
export var ErrorBoundary = /*#__PURE__*/function (_Component) {
  _inherits(ErrorBoundary, _Component);

  var _super = _createSuper(ErrorBoundary);

  function ErrorBoundary(props) {
    var _this;

    _classCallCheck(this, ErrorBoundary);

    _this = _super.call(this, props);
    _this.state = {};
    _this.onError = _this.onError.bind(_assertThisInitialized(_this));
    return _this;
  }

  _createClass(ErrorBoundary, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var globalErrorsManager = this.props.globalErrorsManager;
      globalErrorsManager.removeListener(this.onError);
    }
  }, {
    key: "onError",
    value: function onError(error) {
      var _this2 = this;

      var handlers = this.props.handlers;

      var _loop = function _loop(i) {
        var h = handlers[i];
        if (Reflect.get(error, ALREADY_HANDLED)) return {
          v: true
        };

        if (!Reflect.get(error, ALREADY_HANDLED) && Catch.catches(h, error)) {
          _this2.setState({
            error: error,
            handlerIndex: i
          }, function () {
            var _h$catch;

            return (_h$catch = h["catch"]) === null || _h$catch === void 0 ? void 0 : _h$catch.call(h, error);
          });

          Reflect.set(error, ALREADY_HANDLED, true);
          Reflect.set(error, HANDLER_INDEX, i);
          return {
            v: true
          };
        }
      };

      for (var i = handlers.length - 1; i >= 0; i--) {
        var _ret = _loop(i);

        if (_typeof(_ret) === "object") return _ret.v;
      }

      return false;
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          globalErrorsManager = _this$props.globalErrorsManager,
          handlers = _this$props.handlers;
      globalErrorsManager.removeListener(this.onError);
      globalErrorsManager.addListener(this.onError);

      if (this.state.error != null) {
        var _this$state$handlerIn;

        var index = (_this$state$handlerIn = this.state.handlerIndex) !== null && _this$state$handlerIn !== void 0 ? _this$state$handlerIn : -1;
        var handler = handlers[index];
        return typeof (handler === null || handler === void 0 ? void 0 : handler.render) === 'function' ? handler.render(this.state.error) : this.props.children;
      }

      return this.props.children;
    }
  }], [{
    key: "getDerivedStateFromError",
    value: function getDerivedStateFromError(error) {
      return {
        error: error,
        handlerIndex: Reflect.get(error, HANDLER_INDEX)
      };
    }
  }]);

  return ErrorBoundary;
}(Component);